<template>
    <button
        class="tw-inline-flex tw-items-center tw-p-2 tw-text-sm lg:tw-text-base tw-bg-slate-800 tw-text-white tw-opacity-[.72] lg:hover:tw-opacity-[.88] tw-h-full hover:tw-cursor-pointer"
        :class="{
            [`media-counter--disabled`]: disabled,
            'media-counter--clickable': clickable,
        }"
        @click="onClick"
    >
        <slot></slot>
    </button>
</template>

<script>
/**
 * Media counter badge component
 *
 * @version 4.0.0
 * @example ./../examples/MediaCounter.md
 */
export default {
    name: 'DkMediaCounter',
    props: {
        /**
         * Whether or not it's clickable
         */
        clickable: {
            type: Boolean,
            default: false,
        },
        /**
         * Whether or not it's disabled
         */
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        onClick(...args) {
            if (!this.clickable || this.disabled) {
                return;
            }

            /**
             * Fired when `clickable`, not `disabled` and clicked
             *
             * @event click
             * @type {object}
             */
            this.$emit('click', ...args);
        },
    },
};
</script>
